import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditValue from "../../components/values/FormAddEditValue";

const CreateValue = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/values");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditValue
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateValue;
